import { h } from "preact";
import { useEffect, useLayoutEffect, useRef, useState } from "preact/hooks";

import { addHighlightSpans, classNames, renderHtml } from "../helpers";
import tracking from "../tracking/tracking";

import Button from "./Button.jsx";
import Checkbox from "./Checkbox.jsx";
import Icon from "./Icon.jsx";
import ListItem from "./ListItem.jsx";
import TextField from "./TextField.jsx";
import i18n from "../i18n";
import scrollStateChecker from "../services/scrollStateChecker";

export default function ModalSelector({
  label,
  items,
  onSelect,
  onClose,
  withFilter,
  placeholder,
  onFilterChange,
  useOwnFilter,
  singleSelect,
}) {
  const contentRef = useRef();
  const [filterValue, setFilterValue] = useState("");
  let possibleItems = items;
  if (!useOwnFilter && withFilter && filterValue.length > 0) {
    possibleItems = possibleItems.filter((item) =>
      item.filter
        ? item.filter(filterValue)
        : item.value.toLowerCase().indexOf(filterValue) > -1
    );
  }

  function handleFilterChange(event) {
    const value = event.target.value.toLowerCase();
    setFilterValue(value);
  }
  function handleCheckChanged(event, item) {
    onSelect(item);
  }

  useEffect(() => {
    document.body.classList.add("--modal-selector-opened");
    return () => {
      document.body.classList.remove("--modal-selector-opened");
    };
  }, []);
  useLayoutEffect(
    () =>
      scrollStateChecker(
        contentRef.current,
        "modal-selector__content--scrolled"
      ),
    [contentRef]
  );

  useEffect(() => {
    onFilterChange && onFilterChange(filterValue);
  }, [filterValue]);

  return (
    <div class={classNames("modal-selector")}>
      {withFilter && (
        <div class="modal-selector__filter">
          <TextField
            type="text"
            label={label}
            placeholder={placeholder}
            onInput={handleFilterChange}
            value={filterValue}
            class="mb-0"
          />
          <Icon
            class={classNames(
              "modal-selector__filter-closer",
              filterValue && "modal-selector__filter-closer--visible"
            )}
            onClick={() => setFilterValue("")}
          >
            close
          </Icon>
        </div>
      )}
      <div class="modal-selector__content" ref={contentRef}>
        <div className="modal-selector__list">
          {possibleItems.map((item, index) => (
            <div key={item.value} class="modal-selector__item">
              {singleSelect ? (
                <div class="modal-selector__itemContent">
                  {item.content && typeof item.content === "function"
                    ? item.content(filterValue)
                    : renderHtml(
                        addHighlightSpans(
                          item.content || item.text,
                          filterValue
                        )
                      )}
                </div>
              ) : (
                <ListItem
                  labelFor={`modal-selector-item-${item.value}`}
                  secondLine={item.description}
                  iconFront={
                    <input
                      type="checkbox"
                      onInput={(event) => handleCheckChanged(event, item)}
                      checked={item.selected}
                      id={`modal-selector-item-${item.value}`}
                    />
                  }
                >
                  {item.content && typeof item.content === "function"
                    ? item.content(filterValue)
                    : renderHtml(
                        addHighlightSpans(
                          item.content || item.text,
                          filterValue
                        )
                      )}
                </ListItem>
              )}
            </div>
          ))}
        </div>
      </div>
      <div class="modal-selector__button-bar">
        <Button onClick={onClose}>{i18n.t("actions.apply")}</Button>
      </div>
    </div>
  );
}
